import { postSecurityQuestionInfo } from "../../services/SecurityQuestionService";
import { SecurityQuestionResult } from "../../services/SecurityQuestionService";
import { ThunkActionType } from "../actions/types";

export const saveSecurityQuestionInfo = (
    selectedQuestion: string,
    answer: string
): ThunkActionType<Promise<SecurityQuestionResult>> => {
    return async (dispatch, getState) => {
        try {
            // Create the thunk action
            const action = postSecurityQuestionInfo(selectedQuestion, answer);

            // Execute the thunk and capture its result
            const thunkResult = await action(dispatch, getState, undefined);

            if (!thunkResult) {
                throw new Error('No result received from security question service');
            }

            return thunkResult;
        } catch (error) {
            console.error('Error in saveSecurityQuestionInfo:', error);
            // Return a failed result with detailed error
            const errorMessage = error instanceof Error
                ? error.message
                : typeof error === 'string'
                    ? error
                    : 'Failed to save security question';

            console.error('Detailed error:', errorMessage); // Debug log

            return {
                isSuccessful: false,
                errorMessage: errorMessage
            };
        }
    };
};

